<breadcrumb [breadcrumbList]="breadcrumbList"></breadcrumb>
@if (navbar.userAccess?.Mailbox=='Full' || navbar.userAccess?.Mailbox=='Readonly') {
@if (showLoader || showMailLoader) {
<div class="loader text-center">
	<img src="../../../assets/img/loading.gif" />
</div>
}
<div class="row">
	<div class="col">
		<div class="card">
			<div class="card-header bg-theme mb-0">
				<h5 class="card-title text-light mb-0">
					{{followUpDetails?.case_id?.case_id}}
				</h5>
			</div>
			<div class="card-body">
				<div class="row g-0 mb-2">
					<div class="col">
						<form [formGroup]="moduleForm" (ngSubmit)="saveReport_A()" #modform="ngForm">
							@if(followUpDetails){
							<div class="row mb-2">
								<div class="col">
									<div class="form-floating">
										<input [ngClass]="{'is-invalid':showError('report_no')}" placeholder=""
											formControlName="report_no" id="report_no" class="form-control" />
										<label for="report_no">
											Report No.
										</label>
									</div>
									@if (showError('report_no')) {
									<p class="text-danger mb-0">
										@if (f.report_no.errors?.required) {
										Required
										}
										@if (f.report_no.errors?.pattern) {
										Invalid
										}
									</p>
									}
								</div>
							</div>
							<div class="row mb-2">
								<div class="col">
									<div class="form-floating">
										<textarea [ngClass]="{'is-invalid':showError('brief_history')}" placeholder=""
											formControlName="brief_history" id="brief_history" class="form-control">
										</textarea>
										<label for="brief_history">
											Brief History
										</label>
									</div>
									@if (showError('brief_history')) {
									<p class="text-danger mb-0">
										@if (f.brief_history.errors?.required) {
										Required
										}
									</p>
									}
								</div>
							</div>
							<div class="row mb-2">
								<div class="col">
									<div class="form-floating">
										<textarea [ngClass]="{'is-invalid':showError('further_advice')}" placeholder=""
											formControlName="further_advice" id="further_advice" class="form-control">
										</textarea>
										<label for="further_advice">
											Further Advice
										</label>
									</div>
									@if (showError('further_advice')) {
									<p class="text-danger mb-0">
										@if (f.further_advice.errors?.required) {
										Required
										}
									</p>
									}
								</div>
							</div>
							<div class="row mb-2">
								<div class="col">
									<ng-select [ngClass]="{'is-invalid':showError('previous_followups')}"
										[items]="prevFollList" bindValue="id" [clearable]="true" [multiple]="true"
										placeholder="Previous Follow-ups" formControlName="previous_followups"
										appearance="outline">
										<ng-template ng-label-tmp let-item="item">
											{{item.follow_up_date}}
											&nbsp;|&nbsp;
											{{item.visit_type?.name}}
											<span class="badge fw-bold text-dark"
												[ngClass]="getFollowUpStatusClass(item.follow_up_status?.id)">
												{{ item?.follow_up_status?.name }}
											</span>
										</ng-template>
										<ng-template ng-option-tmp let-item="item" let-search="searchTerm"
											let-index="index">
											{{item.follow_up_date}}
											&nbsp;|&nbsp;
											{{item.visit_type?.name}}
											<span class="badge fw-bold text-dark"
												[ngClass]="getFollowUpStatusClass(item.follow_up_status?.id)">
												{{ item?.follow_up_status?.name }}
											</span>
										</ng-template>
									</ng-select>
									@if(showError('previous_followups')){
									<p class="text-danger">
										@if(f.previous_followups.errors?.required){
										Required
										}
									</p>
									}
								</div>
							</div>
							}
							<!-- <div class="row mb-2">
								<div class="col-md-6">
									<div class="input-group">
										<div class="form-floating">
											<input class="form-control"
												[ngClass]="{'is-invalid':showError('next_review_date')}" placeholder=""
												formControlName="next_review_date" ngbDatepicker id="next_review_date"
												#next_review_date="ngbDatepicker" [minDate]="minDate"
												[container]="'body'" />
											<label for="next_review_date">Next Review Date</label>
										</div>
										<button class="btn btn-outline-secondary" (click)="next_review_date.toggle()"
											type="button">
											<fa-icon [icon]="['fas', 'calendar-week']"></fa-icon>
										</button>
									</div>
									@if (showError('next_review_date')) {
									<p class="text-danger">
										@if(f.next_review_date.errors?.required){
										Required
										}
									</p>
									}
								</div>
							</div> -->
							<!-- <div class="row mb-2">
								<div class="col-md-6">
									<div class="form-floating">
										<input [ngClass]="{'is-invalid':showError('expected_treatment_period')}"
											placeholder="" formControlName="expected_treatment_period"
											id="expected_treatment_period" class="form-control" />
										<label for="expected_treatment_period">
											Expected Treatment Period
										</label>
									</div>
									@if (showError('expected_treatment_period')) {
									<p class="text-danger mb-0">
										@if (f.expected_treatment_period.errors?.required) {
										Required
										}
									</p>
									}
								</div>
								<div class="col-md-6">
									<div class="form-floating">
										<input [ngClass]="{'is-invalid':showError('expected_treatment_cost')}"
											placeholder="" formControlName="expected_treatment_cost"
											id="expected_treatment_cost" class="form-control" />
										<label for="expected_treatment_cost">
											Expected Treatment Cost
										</label>
									</div>
									@if (showError('expected_treatment_cost')) {
									<p class="text-danger mb-0">
										@if (f.expected_treatment_cost.errors?.required) {
										Required
										}
									</p>
									}
								</div>
							</div> -->
							<!-- <div class="row mb-2">
								<div class="col-md-12">
									<div class="form-floating">
										<input [ngClass]="{'is-invalid':showError('further_advice')}" placeholder=""
											formControlName="further_advice" id="further_advice" class="form-control" />
										<label for="further_advice">
											Further Advice
										</label>
									</div>
									@if (showError('further_advice')) {
									<p class="text-danger mb-0">
										@if (f.further_advice.errors?.required) {
										Required
										}
									</p>
									}
								</div>
							</div> -->
							<!-- <div class="row mb-2">
								<div class="col-md-12">
									<div class="form-floating">
										<input [ngClass]="{'is-invalid':showError('fitness_status')}" placeholder=""
											formControlName="fitness_status" id="fitness_status" class="form-control" />
										<label for="fitness_status">
											Fitness Status
										</label>
									</div>
									@if (showError('fitness_status')) {
									<p class="text-danger mb-0">
										@if (f.fitness_status.errors?.required) {
										Required
										}
									</p>
									}
								</div>
							</div> -->
							<!-- <div class="row mb-2">
								<div class="col-md-12">
									<ng-select [ngClass]="{'is-invalid':showError('previous_followups')}"
										[items]="prevFollList" bindValue="id" [clearable]="true" [multiple]="true"
										placeholder="Previous Follow-ups" formControlName="previous_followups"
										appearance="outline">
										<ng-template ng-label-tmp let-item="item">
											{{item.follow_up_date}}
											&nbsp;|&nbsp;
											{{item.visit_type?.name}}
											<span class="badge fw-bold text-dark"
												[ngClass]="getFollowUpStatusClass(item.follow_up_status?.id)">
												{{ item?.follow_up_status?.name }}
											</span>
										</ng-template>
										<ng-template ng-option-tmp let-item="item" let-search="searchTerm"
											let-index="index">
											{{item.follow_up_date}}
											&nbsp;|&nbsp;
											{{item.visit_type?.name}}
											<span class="badge fw-bold text-dark"
												[ngClass]="getFollowUpStatusClass(item.follow_up_status?.id)">
												{{ item?.follow_up_status?.name }}
											</span>
										</ng-template>
									</ng-select>
									@if(showError('previous_followups')){
									<p class="text-danger">
										@if(f.previous_followups.errors?.required){
										Required
										}
									</p>
									}
								</div>
							</div> -->
							@if(get_rows.length){
							<div class="row mb-2">
								<div class="col-md-12">
									<table class="table table-bordered">
										<thead>
											<tr>
												<th>FAQ</th>
											</tr>
										</thead>
										<tbody>
											@for (creds of get_rows.controls; track $index) {
											<tr formArrayName="faq">
												<ng-container [formGroupName]="$index">
													<td>
														<p class="mb-1 fw-bold">
															{{$index + 1}}
															.&nbsp;
															{{creds.get('question')?.value}}
														</p>
														<div class="form-floating">
															<input
																[ngClass]="{'is-invalid':showError2($index,'answer')}"
																placeholder="" formControlName="answer"
																class="form-control" />
															<label>
																Answer
															</label>
														</div>
														@if(showError2($index,'answer')){
														<p class="text-danger mb-0">
															@if (creds.get('answer')?.errors?.required) {
															Required
															}
														</p>
														}
													</td>
												</ng-container>
											</tr>
											}
										</tbody>
									</table>
								</div>
							</div>
							}
							<div class="row mb-2">
								<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
									<mat-checkbox [color]="'primary'" formControlName="followup_report_sent"
										id="followup_report_sent">
										Report sent
									</mat-checkbox>
								</div>
							</div>
							<div class="row mb-2">
								<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
									@if (navbar.userAccess?.Follow_up_report=='Full'){
									<button type="submit" class="btn btn-sm btn-success me-1"
										[disabled]="saveLoader || !modform.dirty">
										@if (saveLoader) {
										<fa-icon [icon]="['fas', 'spinner']" animation="spin"></fa-icon>
										}@else {
										<fa-icon [icon]="['fas', 'save']"></fa-icon>
										}
										Save
									</button>
									}
									<a type="button" class="btn btn-sm btn-secondary"
										[routerLink]="['/app/appt-details','no',uId,followId]">
										Cancel
									</a>
								</div>
							</div>
						</form>
					</div>
				</div>
				<div class="row g-0 mb-2">
					<div class="col">
						<ng-select [items]="mailList" bindValue="id" [clearable]="true" placeholder="Select trail mail"
							[(ngModel)]="selectedMail" appearance="outline" class="mail-select"
							(change)="getMailDetails()" [loading]="isListLoading">
							<ng-template ng-label-tmp let-mail="item">
								<ng-container *ngTemplateOutlet="mail_template; context: { $implicit: mail }">
								</ng-container>
							</ng-template>
							<ng-template ng-option-tmp let-mail="item" let-search="searchTerm" let-index="index">
								<ng-container *ngTemplateOutlet="mail_template; context: { $implicit: mail }">
								</ng-container>
							</ng-template>
						</ng-select>
						<ng-template #mail_template let-mail>
							<div class="d-flex">
								@if (
								mail.email_status=='unread' ||
								mail.email_status=='read'
								) {
								<div class="me-2">
									<app-mail-dir-icon [direction]="'in'"></app-mail-dir-icon>
								</div>
								}@else if(
								mail.email_status=='sent' ||
								mail.email_status=='draft'
								){
								<div class="me-2">
									<app-mail-dir-icon [direction]="'out'"></app-mail-dir-icon>
								</div>
								}
								<div class="me-1">
									<p class="mb-0">
										@if(mail.email_status =='read' || mail.email_status =='unread'){
										@if (mail.from_name) {
										<strong class="mailbox-from" matTooltip="{{mail.from_email}}">
											{{mail.from_name | limitTo : '30'}}
										</strong>
										}@else {
										<strong class="mailbox-from" matTooltip="{{mail.from_email}}">
											{{mail.from_email | limitTo : '30'}}
										</strong>
										}
										}@else if(mail.email_status =='sent' || mail.email_status =='draft'){
										@if (mail.to_name) {
										<strong class="mailbox-from">
											{{mail.to_name | limitTo : '30'}}
										</strong>
										}@else {
										<strong class="mailbox-from">
											@for (data of mail.toEmailList; track $index) {
											<span matTooltip="{{data}}">
												{{data | limitTo : '30' }}
												<br />
											</span>
											}
										</strong>
										}
										}
									</p>
									<p class="mailbox-subject mb-0">
										{{mail.subject | limitTo : '30'}}
									</p>
								</div>
								<div class="ms-auto d-flex flex-column">
									@if (mail.attachmentsArr.length) {
									<fa-icon [icon]="['fas', 'paperclip']" class="float-end ms-auto"
										matTooltip="Contains attachments">
									</fa-icon>
									}
									@if (mail.sent_by_name) {
									<span class="badge badge-secondary float-end ms-auto"
										matTooltip="Sent By:{{mail.sent_by_name}}">
										{{getInitials(mail.sent_by_name)}}
									</span>
									}
								</div>
							</div>
							<div>
								<span class="text-nowrap float-end">
									<span class="mailbox-date">
										{{mail.messageDate}}
									</span>
								</span>
							</div>
						</ng-template>
					</div>
				</div>
				@if(isReply){
				<div class="row g-0 mb-2">
					<div class="col">
						<form [formGroup]="form">
							<app-mail-form formControlName="mail"></app-mail-form>
						</form>
					</div>
				</div>
				<div class="row g-0 mb-2">
					<div class="col">
						<app-file-uploader #fileUploaderComponent (reportAttached)="reportAttached($event)">
						</app-file-uploader>
					</div>
				</div>
				<div class="row g-0 mb-2">
					<div class="col">
						@if (!fileUploaderComponent.isReportAttached()) {
						<button (click)="attachReport()" class="btn btn-xs btn-primary me-1">
							<fa-icon [icon]="['fas', 'file']"></fa-icon>
							Attach Report
						</button>
						}
						<button class="btn btn-xs btn-success me-1" (click)="saveMail('save_reply_draft')">
							<fa-icon [icon]="['fas', 'save']"></fa-icon>
							Save Draft
						</button>
						<button class="btn btn-xs btn-success me-1" (click)="saveMail('mail_reply_message')">
							<fa-icon [icon]="['fas', 'paper-plane']"></fa-icon>
							Send
						</button>
					</div>
				</div>
				}
				@if(viewMail){
				<div class="row g-0 mb-2">
					<div class="col">
						<app-mail-display [mail]="viewMail" [showTrail]="false" [showReplyBtn]="false" [apptId]="uId"
							[hideMain]="viewMail?.email_status=='draft'" [allowBillingLink]="false"
							(mail_html_fetched)="mail_html_fetched($event)">
						</app-mail-display>
					</div>
				</div>
				}
			</div>
		</div>
	</div>
	<div class="col">
		<div class="card">
			<div class="card-header bg-theme mb-0">
				<h5 class="card-title text-white mb-0">
					Report
				</h5>
			</div>
			<div class="card-body pt-0">
				@if (pageLoading3) {
				<div class="report-loader text-center">
					<img src="../../../assets/img/loading.gif" />
				</div>
				}@else{
				@if (showReport) {
				<button class="btn btn-success btn-sm ms-3 float-end my-1" (click)="downloadReport()"
					[disabled]="downloadLoader">
					@if (downloadLoader) {
					<fa-icon [icon]="['fas','spinner']" [animation]="'spin'"></fa-icon>
					}@else {
					<fa-icon [icon]="['fas','download']"></fa-icon>
					}
					Download
				</button>
				<iframe class="pdf-container" [src]="fileURL" type="application/pdf"></iframe>
				}
				}
			</div>
		</div>
	</div>
</div>
}@else {
<div>
	<h3 class="text-center">You don't have access to this section.</h3>
</div>
}